import { useEffect, useState } from 'react';
import axiosInstance from 'services/axiosInstance';
import useLoading from "../../../../hooks/useLoading";
import LayoutDetails from '../../../LayoutModal/LayoutDetails';
import Loading from '../../../Loading';
import * as S from './style';
//Interface
import { ICard } from 'Interfaces/ICard';
// utils
import FormatarData from 'utils/FormatData';
import { formatPercentage } from 'utils/CurrencyFormat';
interface IDetails {
    isOpenModal: boolean;
    setModalClose: () => void;
    selectedUrlId: number | null;
}

export default function Details({ isOpenModal, setModalClose, selectedUrlId }: IDetails) {
    const [data, setData] = useState<ICard | null>(null);
    const { isLoading, startLoading, stopLoading } = useLoading();

    const fetchData = async () => {
        startLoading();
        try {
            const response = await axiosInstance.get(`card/${selectedUrlId}`);
            setData(response.data);
        } catch (error) {
            console.log('Error: ', error);
        } finally {
            stopLoading();
        }
    }

    useEffect(() => {
        if (isOpenModal && selectedUrlId !== null) {
            fetchData();
        }
    }, [isOpenModal, selectedUrlId])

    if (isOpenModal) {
        return (
            <LayoutDetails
                title='Detalhes da Taxa do Cartão'
                subTitle='Veja todos os detalhes disponíveis sobre a taxa.'
                setModalClose={setModalClose}>
                {isLoading || !data ? ( // Se estiver carregando ou os dados forem nulos, mostra o loading
                    <Loading />
                ) : (
                    <S.Content>
                        <S.Header>
                            <S.ContentInfor>
                                <S.Infor>
                                    <p>Parcela:</p>
                                    <span>{data.number_installment || '-'}x</span>
                                </S.Infor>
                                <S.Infor>
                                    <p>Taxa:</p>
                                    <span>{formatPercentage(parseFloat(data.interest_rate || '0'))}</span>
                                </S.Infor>
                            </S.ContentInfor>
                        </S.Header>

                        <S.Body>
                            <S.InforBody>
                                <S.InforSmall>Cadastrado em: {FormatarData(data.created_at || "-")}</S.InforSmall>
                                <S.InforSmall>Ultima atualização em: {FormatarData(data.updated_at) || "-"}</S.InforSmall>
                            </S.InforBody>
                        </S.Body>
                    </S.Content>
                )}
            </LayoutDetails>
        )
    } return null
}